import type { TFunction } from "i18next";
import { EnergyDataStatus } from "../models/energyDataQuality";

export function statusLabel(status: EnergyDataStatus, t: TFunction): string {
  switch (status) {
    case "ok":
      return t("energyReport.quality.ok");
    case "partial":
      return t("energyReport.quality.partial");
    case "missing":
      return t("energyReport.quality.missing");
    case "failed":
      return t("energyReport.quality.failed");
    case "pending":
      return t("energyReport.quality.pending");
    case "notRead":
      return t("energyReport.quality.notRead");
  }
}
